import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=074d6d82&"
import script from "./ResourceList.vue?vue&type=script&lang=js&"
export * from "./ResourceList.vue?vue&type=script&lang=js&"
import style0 from "./ResourceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCardTitle,VList,VListItemContent,VListItemTitle})
